import { ACTION_CREATE } from '../../request';
import { Voter } from '../voter';

export class PagesVoter extends Voter {
    static getLimitByRole(role) {
        switch (role) {
            case 'basic':
                return 1;
            case 'business400':
                return 50;
            case 'start400':
            case 'pro400':
            default:
                return 10;
        }
    }

    supports(request) {
        return request.resource === 'pages';
    }

    vote(request) {
        if (request.includes(ACTION_CREATE) && !this.canCreate(request)) {
            return false;
        }
    }

    canCreate(request) {
        const pagesCount = request.get('website.counters.pages', 0);
        const roleLimit = PagesVoter.getLimitByRole(request.role);

        return pagesCount < roleLimit;
    }
}
